import { Contact, DefaultService as UsersService } from "@/api/SolarCloudApi";
import { MutationConfig } from "@/lib/react-query";
import { useMutation } from "@tanstack/react-query";

export function registerContact(contact: Contact): Promise<void> {
  return UsersService.registerContact(contact);
}

type UseRegisterContactOptions = {
  mutationConfig?: MutationConfig<typeof registerContact>;
};

export function useRegisterContact({
  mutationConfig,
}: UseRegisterContactOptions = {}) {
  return useMutation({
    mutationFn: registerContact,
    ...mutationConfig,
  });
}